export enum SizesEnum {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  Short = 'short',
}
